<section class="md-checkbox__custom form-element-validation" ref="input" :class="{'error': isRequired}">
    <section class="md-checkbox__custom--fake" :class="{'checked': content, 'disabled': disabled}" @click="toggle">
      <input
        type="checkbox"
        class="md-checkbox__custom--input"
        :class="{'disabled': disabled}"
        v-model="content"
        :disabled="disabled"
        :required="required"
      >
      <span class="md-checkbox__custom--icon" v-if="content">
        <i class="fas fa-check"></i>
      </span>
    </section>
    <label class="md-checkbox__custom--label" :class="{'disabled': disabled}">{{ label }}</label>
  </section>